var React = require('react');

function ScaleInline (props) {
    return React.createElement("g",props,[React.createElement("polygon",{"points":"11.4,14 9.9,12.6 5,17.6 5,14 3,14 3,21 10,21 10,19 6.4,19 ","key":0}),React.createElement("polygon",{"points":"14.2,3 14.2,5 17.7,5 12.8,9.9 14.2,11.4 19.2,6.4 19.2,10 21.2,10 21.2,3 ","key":1})]);
}

ScaleInline.defaultProps = {};

module.exports = ScaleInline;

ScaleInline.default = ScaleInline;
